import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { MONTHS, YEARS } from "@/lib/donation";

export const PeriodFilter = ({ month, year, setMonth, setYear, prefix }) => (
  <div className="flex flex-wrap items-center gap-2">
    <Select value={month} onValueChange={setMonth}>
      <SelectTrigger className="w-40 rounded-full" data-testid={`${prefix}-month-filter`}><SelectValue placeholder="Semua Bulan" /></SelectTrigger>
      <SelectContent>
        <SelectItem value="all">Semua Bulan</SelectItem>
        {MONTHS.map((m, i) => <SelectItem key={m} value={String(i + 1)}>{m}</SelectItem>)}
      </SelectContent>
    </Select>
    <Select value={year} onValueChange={setYear}>
      <SelectTrigger className="w-36 rounded-full" data-testid={`${prefix}-year-filter`}><SelectValue placeholder="Semua Tahun" /></SelectTrigger>
      <SelectContent>
        <SelectItem value="all">Semua Tahun</SelectItem>
        {YEARS.map((y) => <SelectItem key={y} value={String(y)}>{y}</SelectItem>)}
      </SelectContent>
    </Select>
  </div>
);

export const periodParams = (month, year) => {
  const p = new URLSearchParams();
  if (year !== "all") p.set("year", year);
  if (month !== "all" && year !== "all") p.set("month", month);
  return p.toString();
};
